// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closebtn {\n  float: right;\n  margin-top: -30px;\n  font-size: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
